import React from 'react'
import UserProfileContainer from '../../../../Components/Applications/Users/UserProfile'

export default function UserProfile() {
  return (
    <div className='page-body'>
      <UserProfileContainer />
    </div>
  )
}